import './Tooltip.css'
import React from 'react'

// Tooltip universel — enveloppe n'importe quel élément pour afficher un label au hover
let Tooltip: React.FC<{
  label: string
  children: React.ReactNode
  position?: 'top' | 'bottom' | 'left' | 'right'
}> = ({ label, children, position = 'top' }) => (
  <span className={`ice-tooltip ice-tooltip-${position}`} data-tooltip={label}>
    {children}
  </span>
)

export default Tooltip
